export default __webpack_public_path__ + "/dist/images/2354117.dae2a776260a46122b59da970f031c52.png";